import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Subject, tap } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({ providedIn: 'root' })
export class RelationshipService {

    private http = inject(HttpClient);
    private platformId = inject(PLATFORM_ID);
    private baseUrl = `${environment.apiUrl}/follows`;

    private refreshEvents$ = new Subject<void>();
    onRefreshEvents$ = this.refreshEvents$.asObservable();

    /** Fires after a follow / unfollow succeeds anywhere, so every place showing
     *  that person's Follow button can stay in sync without a reload. */
    private followChangedSubject = new Subject<{ userId: string; isFollowed: boolean }>();
    followChanged$ = this.followChangedSubject.asObservable();

    follow(userId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.post<any>(`${this.baseUrl}/${userId}/follow`, {}).pipe(
            tap(() => this.followChangedSubject.next({ userId, isFollowed: true })),
        );
    }

    unfollow(userId: string) {
        if (!isPlatformBrowser(this.platformId)) return EMPTY;
        return this.http.delete<any>(`${this.baseUrl}/${userId}/unfollow`, {}).pipe(
            tap(() => this.followChangedSubject.next({ userId, isFollowed: false })),
        );
    }
}